import { EventsListType, EventType } from "../SchedulingTypes";
import { saveData } from "services/api/saveData";
import { convertLocalDateTimeToUTC } from "internationalization/timezoneConversions";
import { convertDayKeyAndTimeSlotToEndDateTimeString, generateTimeKeyFromDateTimeString } from "./schedulingDateUtils";

// Persists the new duration of a resized appointment event and updates the events state
export const handleAppointmentResize = async (
    resizedEvent: EventType,
    newDurationMinutes: number,
    userLocale: string,
    userTimezone: string,
    setEvents: React.Dispatch<React.SetStateAction<EventsListType>>,
) => {
    // Only appointment events with a known start can be resized
    if (resizedEvent.type !== 'appointment' || !resizedEvent.appointmentId || !resizedEvent.dayKey || !resizedEvent.startTime || !resizedEvent.startDateTime) return;

    // Build the new local end datetime from the unchanged start time and the new duration
    const convertedEndDateTime = convertDayKeyAndTimeSlotToEndDateTimeString(resizedEvent.dayKey, resizedEvent.startTime, newDurationMinutes, userLocale, userTimezone);

    // Update every event entry of this appointment, one entry exists per assigned resource
    setEvents(previousEvents => {
        const updatedEvents = { ...previousEvents };
        Object.entries(previousEvents).forEach(([key, event]) => {
            if (event.type === 'appointment' && event.appointmentId === resizedEvent.appointmentId) {
                updatedEvents[key] = {
                    ...event,
                    endDateTime: convertedEndDateTime,
                    endTime: generateTimeKeyFromDateTimeString(convertedEndDateTime),
                    durationMinutes: newDurationMinutes,
                };
            }
        });
        return updatedEvents;
    });

    // Convert the local datetimes to utc datetimes
    const utcStartDateTime = convertLocalDateTimeToUTC(resizedEvent.startDateTime, userLocale, userTimezone);
    const utcEndDateTime = convertLocalDateTimeToUTC(convertedEndDateTime, userLocale, userTimezone);

    // Save the appointment with its new end time
    await saveData({
        apiUrl: `patch_appointment/${resizedEvent.appointmentId}`,
        method: 'patch',
        data: {
            id: resizedEvent.appointmentId,
            timezone: userTimezone,
            start_datetime: utcStartDateTime,
            end_datetime: utcEndDateTime,
        },
    });
};
